import React from 'react';
import htmlDecode from '../helpers/htmlDecode';
import toSnakeCase from '../../../helpers/to_snake_case';

function BroadenSearchOptions({
  broadenSearchOptions: options,
  handleClickBroaden,
  totalResults,
  localisations,
}) {
  return options ? (
    <div className="broaden-options">
      <h2 className="heading heading--sub">
        {localisations.only} {totalResults}{' '}
        {totalResults == 1
          ? `${localisations.result}`
          : `${localisations.results}`}
        , {localisations.broaden_your_criteria}
      </h2>
      <ul className="broaden-options__list">
        {options.map((option, index) => {
          return (
            <li
              className="broaden-options__item"
              key={`${option.num_matches} ${option.criteria_to_lose_string ||
                option.criteria_to_add_string}`}
            >
              <strong>{option.num_matches}</strong>{' '}
              {localisations.matches_found_for}{' '}
              <a
                href={`#${option.url}`}
                id={`broaden${index}`}
                onClick={(event) =>
                  handleClickBroaden(
                    event,
                    option.remove_params,
                    option.add_params,
                  )
                }
              >
                {htmlDecode(option.criteria_to_keep_string)}
              </a>{' '}
              <span className="broaden-options__remove-criteria">
                {option.criteria_to_lose_string
                  ? htmlDecode(option.criteria_to_lose_string)
                  : null}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
}

export default BroadenSearchOptions;
